import { useAuth } from "../contexts/AuthContext";

export function NoDataOverlay() {
  const { t } = useAuth();
  return (
    <div className="p-4">
      <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 text-center">
        <div className="text-4xl mb-2">📭</div>
        <div className="text-sm font-semibold text-amber-900">{t("no_data_title")}</div>
        <div className="text-xs text-amber-700 mt-1.5 leading-relaxed">{t("no_data_note")}</div>
      </div>
    </div>
  );
}
